{
  "name": "cash-link-crm",
  "$schema": "../../../node_modules/nx/schemas/project-schema.json",
  "projectType": "application",
  "prefix": "clc",
  "sourceRoot": "apps/cash-link/cash-link-crm/src",
  "tags": [],
  "targets": {
    "build": {
      "executor": "@angular-devkit/build-angular:application",
      "dependsOn": [
        "^build",
        "dedupe-firebase",
        {
          "target": "validate-prod-env",
          "params": "forward"
        }
      ],
      "outputs": ["{options.outputPath}"],
      "options": {
        "outputPath": "dist/apps/cash-link/cash-link-crm",
        "index": "apps/cash-link/cash-link-crm/src/index.html",
        "browser": "apps/cash-link/cash-link-crm/src/main.ts",
        "polyfills": ["zone.js"],
        "tsConfig": "apps/cash-link/cash-link-crm/tsconfig.app.json",
        "inlineStyleLanguage": "scss",
        "assets": [
          "apps/cash-link/cash-link-crm/src/favicon.ico",
          "apps/cash-link/cash-link-crm/src/assets",
          "apps/cash-link/cash-link-crm/src/assets/images",
          "apps/cash-link/cash-link-crm/src/favicon.png",
          "apps/cash-link/cash-link-crm/src/firebase-messaging-sw.js",
          {
            "glob": "**/*",
            "input": "apps/cash-link/cash-link-crm/public",
            "output": "/"
          },
          {
            "glob": "**/*",
            "input": "node_modules/leaflet/dist/images",
            "output": "/assets/img/markers"
          },
          {
            "glob": "firebase-config.js",
            "input": "apps/cash-link/cash-link-crm/src/firebase-sw-config",
            "output": "/"
          }
        ],
        "stylePreprocessorOptions": {
          "includePaths": ["node_modules", "libs/generic/@theme/src/lib/styles"]
        },
        "styles": ["libs/generic/@theme/src/lib/styles/styles.scss", "apps/cash-link/cash-link-crm/src/styles.scss"],
        "allowedCommonJsDependencies": [
          "angular2-chartjs",
          "echarts",
          "lodash",
          "ionicons",
          "leaflet",
          "rfdc",
          "buffer",
          "eva-icons",
          "moment",
          "tinymce",
          "ckeditor",
          "zrender/lib/svg/svg",
          "zrender/lib/vml/vml"
        ],
        "extractLicenses": false,
        "sourceMap": true,
        "optimization": false,
        "namedChunks": true,
        "serviceWorker": "apps/cash-link/cash-link-crm/ngsw-config.json"
      },
      "configurations": {
        "production": {
          "optimization": {
            "scripts": true,
            "styles": {
              "minify": true,
              "inlineCritical": false
            },
            "fonts": true
          },
          "outputHashing": "all",
          "sourceMap": false,
          "namedChunks": false,
          "extractLicenses": true,
          "fileReplacements": [
            {
              "replace": "apps/cash-link/cash-link-crm/src/environments/environment.ts",
              "with": "apps/cash-link/cash-link-crm/src/environments/environment.prod.ts"
            }
          ],
          "assets": [
            "apps/cash-link/cash-link-crm/src/favicon.ico",
            "apps/cash-link/cash-link-crm/src/assets",
            "apps/cash-link/cash-link-crm/src/assets/images",
            "apps/cash-link/cash-link-crm/src/favicon.png",
            "apps/cash-link/cash-link-crm/src/firebase-messaging-sw.js",
            {
              "glob": "**/*",
              "input": "apps/cash-link/cash-link-crm/public",
              "output": "/"
            },
            {
              "glob": "**/*",
              "input": "node_modules/leaflet/dist/images",
              "output": "/assets/img/markers"
            },
            {
              "glob": "firebase-config.js",
              "input": "apps/cash-link/cash-link-crm/src/firebase-sw-config.prod",
              "output": "/"
            }
          ]
        },
        "devProduction": {
          "optimization": {
            "scripts": true,
            "styles": {
              "minify": true,
              "inlineCritical": false
            },
            "fonts": true
          },
          "outputHashing": "all",
          "sourceMap": true,
          "namedChunks": true,
          "extractLicenses": true
        },
        "prodWatch": {
          "optimization": true,
          "outputHashing": "all",
          "sourceMap": false,
          "namedChunks": false,
          "extractLicenses": true,
          "fileReplacements": [
            {
              "replace": "apps/cash-link/cash-link-crm/src/environments/environment.ts",
              "with": "apps/cash-link/cash-link-crm/src/environments/environment.prod.ts"
            }
          ],
          "watch": true,
          "assets": [
            "apps/cash-link/cash-link-crm/src/favicon.ico",
            "apps/cash-link/cash-link-crm/src/assets",
            "apps/cash-link/cash-link-crm/src/assets/images",
            "apps/cash-link/cash-link-crm/src/favicon.png",
            "apps/cash-link/cash-link-crm/src/firebase-messaging-sw.js",
            {
              "glob": "**/*",
              "input": "apps/cash-link/cash-link-crm/public",
              "output": "/"
            },
            {
              "glob": "**/*",
              "input": "node_modules/leaflet/dist/images",
              "output": "/assets/img/markers"
            },
            {
              "glob": "firebase-config.js",
              "input": "apps/cash-link/cash-link-crm/src/firebase-sw-config.prod",
              "output": "/"
            }
          ]
        },
        "development": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true
        }
      },
      "defaultConfiguration": "production"
    },
    "serve": {
      "executor": "@angular-devkit/build-angular:dev-server",
      "options": {
        "verbose": true,
        "port": 4202
      },
      "configurations": {
        "production": {
          "buildTarget": "cash-link-crm:build:devProduction"
        },
        "development": {
          "buildTarget": "cash-link-crm:build:development"
        },
        "rde": {
          "buildTarget": "cash-link-crm:build:development",
          "host": "0.0.0.0"
        }
      },
      "defaultConfiguration": "development"
    },
    "extract-i18n": {
      "executor": "@angular-devkit/build-angular:extract-i18n",
      "options": {
        "buildTarget": "cash-link-crm:build"
      }
    },
    "lint": {
      "executor": "@nx/eslint:lint"
    },
    "test": {
      "executor": "@nx/jest:jest",
      "outputs": ["{workspaceRoot}/coverage/{projectRoot}"],
      "options": {
        "jestConfig": "apps/cash-link/cash-link-crm/jest.config.ts"
      }
    },
    "serve-static": {
      "executor": "@nx/web:file-server",
      "options": {
        "buildTarget": "cash-link-crm:build",
        "staticFilePath": "dist/apps/cash-link/cash-link-crm/browser"
      }
    },
    "dedupe-firebase": {
      "executor": "nx:run-commands",
      "cache": false,
      "options": {
        "command": "node tools/dedupe-firebase.js"
      }
    },
    "validate-prod-env": {
      "executor": "nx:run-commands",
      "cache": false,
      "options": {
        "command": "node tools/validate-crm-prod-env.js"
      },
      "configurations": {
        "development": {
          "command": "node tools/validate-crm-prod-env.js"
        },
        "devProduction": {
          "command": "node tools/validate-crm-prod-env.js"
        },
        "prodWatch": {
          "command": "node tools/validate-crm-prod-env.js"
        },
        "production": {
          "command": "node tools/validate-crm-prod-env.js --strict"
        }
      }
    }
  }
}
